import React, { useState,useEffect } from "react";
import { Link,useNavigate,useParams } from 'react-router-dom';
import BackBtn from "../settings/backBtn";
import HomeContact from "../home/homeContact";
import UploadResume from './uploadResume';
import EducationForm from "./educationForm";
import PersonalDetailsForm from "./personalDetailsForm";
import ReviewForm from "./reviewForm";
import successImg from '../../assets/images/success.png'
import ProfileImage from "../profile/profileImage";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
//import Loader from '../loader/buttonLoader';
import Select from "react-select";
import axios from 'axios';
import api, { baseURL,mediaUrl } from '../axiosInterceptor/axiosInterceptorC';
import { PiCaretRightBold, PiCaretLeftBold } from "react-icons/pi";
import Loader from '../loader/buttonLoader';
import { toast } from 'react-toastify';
import { useGlobalState } from '../globalProvider/globalProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const path = "";
const mediaPath = mediaUrl
//const [errors, setErrors] = useState({});



function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <div>{children}</div>
          </Box>
        )}
      </div>
    );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const locations = [
    { value: "new-york", label: "New York" },
    { value: "san-francisco", label: "San Francisco" },
    { value: "los-angeles", label: "Los Angeles" },
    // Add more options here
];

const place = [
    { value: "new-york", label: "New York" },
    { value: "san-francisco", label: "San Francisco" },
    { value: "los-angeles", label: "Los Angeles" },
    // Add more options here
];

const year = [
    { value: "1year", label: "1 Year" },
    { value: "2years", label: "2 Years" },
    { value: "3years", label: "3 Years" },
    { value: "4years", label: "4 Years" },
    { value: "5years", label: "5 Years" },
    { value: "6years", label: "6 Years" },
    { value: "7years", label: "7 Years" },
    { value: "8years", label: "8 Years" },
    { value: "9years", label: "9 Years" },
    { value: "10years", label: "10 Years" },
    { value: "10Above", label: "10+ Years" },
    // Add more options here
];

const month = [
    { value: "1month", label: "1 Month" },
    { value: "2month", label: "2 Months" },
    { value: "3month", label: "3 Months" },
    { value: "4month", label: "4 Months" },
    { value: "5month", label: "5 Months" },
    { value: "6month", label: "6 Months" },
    { value: "7month", label: "7 Months" },
    { value: "8month", label: "8 Months" },
    { value: "9month", label: "9 Months" },
    { value: "10month", label: "10 Months" },
    { value: "11month", label: "11 Months" },
    // Add more options here
];

const countryCodes = [
    { name: 'Afghanistan', code: '+93', flag: '🇦🇫', phoneLength: 9 },
    { name: 'Albania', code: '+355', flag: '🇦🇱', phoneLength: 9 },
    { name: 'Algeria', code: '+213', flag: '🇩🇿', phoneLength: 9 },
    { name: 'Andorra', code: '+376', flag: '🇦🇩', phoneLength: 6 },
    { name: 'Angola', code: '+244', flag: '🇦🇴', phoneLength: 9 },
    { name: 'Argentina', code: '+54', flag: '🇦🇷', phoneLength: 10 },
    { name: 'Armenia', code: '+374', flag: '🇦🇲', phoneLength: 8 },
    { name: 'Australia', code: '+61', flag: '🇦🇺', phoneLength: 9 },
    { name: 'Austria', code: '+43', flag: '🇦🇹', phoneLength: 10 },
    { name: 'Azerbaijan', code: '+994', flag: '🇦🇿', phoneLength: 9 },
    { name: 'Bahamas', code: '+1-242', flag: '🇧🇸', phoneLength: 7 },
    { name: 'Bahrain', code: '+973', flag: '🇧🇭', phoneLength: 8 },
    { name: 'Bangladesh', code: '+880', flag: '🇧🇩', phoneLength: 10 },
    { name: 'Barbados', code: '+1-246', flag: '🇧🇧', phoneLength: 7 },
    { name: 'Belarus', code: '+375', flag: '🇧🇾', phoneLength: 9 },
    { name: 'Belgium', code: '+32', flag: '🇧🇪', phoneLength: 8 },
    { name: 'Belize', code: '+501', flag: '🇧🇿', phoneLength: 7 },
    { name: 'Benin', code: '+229', flag: '🇧🇯', phoneLength: 8 },
    { name: 'Bhutan', code: '+975', flag: '🇧🇹', phoneLength: 8 },
    { name: 'Bolivia', code: '+591', flag: '🇧🇴', phoneLength: 8 },
    { name: 'Bosnia and Herzegovina', code: '+387', flag: '🇧🇦', phoneLength: 8 },
    { name: 'Botswana', code: '+267', flag: '🇧🇼', phoneLength: 7 },
    { name: 'Brazil', code: '+55', flag: '🇧🇷', phoneLength: 11 },
    { name: 'Brunei', code: '+673', flag: '🇧🇳', phoneLength: 7 },
    { name: 'Bulgaria', code: '+359', flag: '🇧🇬', phoneLength: 7 },
    { name: 'Burkina Faso', code: '+226', flag: '🇧🇫', phoneLength: 8 },
    { name: 'Burundi', code: '+257', flag: '🇧🇮', phoneLength: 8 },
    { name: 'Cabo Verde', code: '+238', flag: '🇨🇻', phoneLength: 7 },
    { name: 'Cambodia', code: '+855', flag: '🇰🇭', phoneLength: 8 },
    { name: 'Cameroon', code: '+237', flag: '🇨🇲', phoneLength: 9 },
    { name: 'Canada', code: '+1', flag: '🇨🇦', phoneLength: 10 },
    { name: 'Central African Republic', code: '+236', flag: '🇨🇫', phoneLength: 7 },
    { name: 'Chad', code: '+235', flag: '🇹🇩', phoneLength: 8 },
    { name: 'Chile', code: '+56', flag: '🇨🇱', phoneLength: 9 },
    { name: 'China', code: '+86', flag: '🇨🇳', phoneLength: 11 },
    { name: 'Colombia', code: '+57', flag: '🇨🇴', phoneLength: 10 },
    { name: 'Comoros', code: '+269', flag: '🇰🇲', phoneLength: 7 },
    { name: 'Congo (Congo-Brazzaville)', code: '+242', flag: '🇨🇬', phoneLength: 8 },
    { name: 'Congo (Democratic Republic of the)', code: '+243', flag: '🇨🇩', phoneLength: 9 },
    { name: 'Costa Rica', code: '+506', flag: '🇨🇷', phoneLength: 8 },
    { name: 'Croatia', code: '+385', flag: '🇭🇷', phoneLength: 9 },
    { name: 'Cuba', code: '+53', flag: '🇨🇺', phoneLength: 8 },
    { name: 'Cyprus', code: '+357', flag: '🇨🇾', phoneLength: 8 },
    { name: 'Czechia', code: '+420', flag: '🇨🇿', phoneLength: 9 },
    { name: 'Denmark', code: '+45', flag: '🇩🇰', phoneLength: 8 },
    { name: 'Djibouti', code: '+253', flag: '🇩🇯', phoneLength: 7 },
    { name: 'Dominica', code: '+1-767', flag: '🇩🇲', phoneLength: 7 },
    { name: 'Dominican Republic', code: '+1-809', flag: '🇩🇴', phoneLength: 10 },
    { name: 'Ecuador', code: '+593', flag: '🇪🇨', phoneLength: 9 },
    { name: 'Egypt', code: '+20', flag: '🇪🇬', phoneLength: 10 },
    { name: 'El Salvador', code: '+503', flag: '🇸🇻', phoneLength: 8 },
    { name: 'Equatorial Guinea', code: '+240', flag: '🇬🇶', phoneLength: 9 },
    { name: 'Eritrea', code: '+291', flag: '🇪🇷', phoneLength: 7 },
    { name: 'Estonia', code: '+372', flag: '🇪🇪', phoneLength: 7 },
    { name: 'Eswatini', code: '+268', flag: '🇸🇿', phoneLength: 8 },
    { name: 'Ethiopia', code: '+251', flag: '🇪🇹', phoneLength: 10 },
    { name: 'Fiji', code: '+679', flag: '🇫🇯', phoneLength: 7 },
    { name: 'Finland', code: '+358', flag: '🇫🇮', phoneLength: 10 },
    { name: 'France', code: '+33', flag: '🇫🇷', phoneLength: 9 },
    { name: 'Gabon', code: '+241', flag: '🇬🇦', phoneLength: 7 },
    { name: 'Gambia', code: '+220', flag: '🇬🇲', phoneLength: 7 },
    { name: 'Georgia', code: '+995', flag: '🇬🇪', phoneLength: 9 },
    { name: 'Germany', code: '+49', flag: '🇩🇪', phoneLength: 11 },
    { name: 'Ghana', code: '+233', flag: '🇬🇭', phoneLength: 9 },
    { name: 'Greece', code: '+30', flag: '🇬🇷', phoneLength: 10 },
    { name: 'Grenada', code: '+1-473', flag: '🇬🇩', phoneLength: 7 },
    { name: 'Guatemala', code: '+502', flag: '🇬🇹', phoneLength: 8 },
    { name: 'Guinea', code: '+224', flag: '🇬🇳', phoneLength: 9 },
    { name: 'Guinea-Bissau', code: '+245', flag: '🇬🇼', phoneLength: 7 },
    { name: 'Guyana', code: '+592', flag: '🇬🇾', phoneLength: 7 },
    { name: 'Haiti', code: '+509', flag: '🇭🇹', phoneLength: 8 },
    { name: 'Honduras', code: '+504', flag: '🇭🇳', phoneLength: 8 },
    { name: 'Hungary', code: '+36', flag: '🇭🇺', phoneLength: 9 },
    { name: 'Iceland', code: '+354', flag: '🇮🇸', phoneLength: 7 },
    { name: 'India', code: '+91', flag: '🇮🇳', phoneLength: 10 },
    { name: 'Indonesia', code: '+62', flag: '🇮🇩', phoneLength: 10 },
    { name: 'Iran', code: '+98', flag: '🇮🇷', phoneLength: 10 },
    { name: 'Iraq', code: '+964', flag: '🇮🇶', phoneLength: 9 },
    { name: 'Ireland', code: '+353', flag: '🇮🇪', phoneLength: 9 },
    { name: 'Israel', code: '+972', flag: '🇮🇱', phoneLength: 9 },
    { name: 'Italy', code: '+39', flag: '🇮🇹', phoneLength: 10 },
    { name: 'Jamaica', code: '+1-876', flag: '🇯🇲', phoneLength: 7 },
    { name: 'Japan', code: '+81', flag: '🇯🇵', phoneLength: 10 },
    { name: 'Jordan', code: '+962', flag: '🇯🇴', phoneLength: 9 },
    { name: 'Kazakhstan', code: '+7', flag: '🇰🇿', phoneLength: 10 },
    { name: 'Kenya', code: '+254', flag: '🇰🇪', phoneLength: 10 },
    { name: 'Kiribati', code: '+686', flag: '🇰🇷', phoneLength: 7 },
    { name: 'Kuwait', code: '+965', flag: '🇰🇼', phoneLength: 8 },
    { name: 'Kyrgyzstan', code: '+996', flag: '🇰🇬', phoneLength: 9 },
    { name: 'Laos', code: '+856', flag: '🇱🇦', phoneLength: 8 },
    { name: 'Latvia', code: '+371', flag: '🇱🇻', phoneLength: 8 },
    { name: 'Lebanon', code: '+961', flag: '🇱🇧', phoneLength: 8 },
    { name: 'Lesotho', code: '+266', flag: '🇱🇸', phoneLength: 8 },
    { name: 'Liberia', code: '+231', flag: '🇱🇷', phoneLength: 7 },
    { name: 'Libya', code: '+218', flag: '🇱🇾', phoneLength: 9 },
    { name: 'Liechtenstein', code: '+423', flag: '🇱🇮', phoneLength: 9 },
    { name: 'Lithuania', code: '+370', flag: '🇱🇹', phoneLength: 8 },
    { name: 'Luxembourg', code: '+352', flag: '🇱🇺', phoneLength: 6 },
    { name: 'Madagascar', code: '+261', flag: '🇲🇬', phoneLength: 9 },
    { name: 'Malawi', code: '+265', flag: '🇲🇼', phoneLength: 9 },
    { name: 'Malaysia', code: '+60', flag: '🇲🇾', phoneLength: 10 },
    { name: 'Maldives', code: '+960', flag: '🇲🇻', phoneLength: 7 },
    { name: 'Mali', code: '+223', flag: '🇲🇱', phoneLength: 8 },
    { name: 'Malta', code: '+356', flag: '🇲🇹', phoneLength: 8 },
    { name: 'Marshall Islands', code: '+692', flag: '🇲🇭', phoneLength: 7 },
    { name: 'Mauritania', code: '+222', flag: '🇲🇦', phoneLength: 8 },
    { name: 'Mauritius', code: '+230', flag: '🇲🇺', phoneLength: 8 },
    { name: 'Mexico', code: '+52', flag: '🇲🇽', phoneLength: 10 },
    { name: 'Micronesia', code: '+691', flag: '🇫🇲', phoneLength: 7 },
    { name: 'Moldova', code: '+373', flag: '🇲🇩', phoneLength: 8 },
    { name: 'Monaco', code: '+377', flag: '🇲🇨', phoneLength: 7 },
    { name: 'Mongolia', code: '+976', flag: '🇲🇳', phoneLength: 8 },
    { name: 'Montenegro', code: '+382', flag: '🇲🇪', phoneLength: 8 },
    { name: 'Morocco', code: '+212', flag: '🇲🇦', phoneLength: 10 },
    { name: 'Mozambique', code: '+258', flag: '🇲🇿', phoneLength: 9 },
    { name: 'Myanmar (formerly Burma)', code: '+95', flag: '🇲🇲', phoneLength: 9 },
    { name: 'Namibia', code: '+264', flag: '🇳🇦', phoneLength: 10 },
    { name: 'Nauru', code: '+674', flag: '🇳🇷', phoneLength: 7 },
    { name: 'Nepal', code: '+977', flag: '🇳🇵', phoneLength: 10 },
    { name: 'Netherlands', code: '+31', flag: '🇳🇱', phoneLength: 9 },
    { name: 'New Zealand', code: '+64', flag: '🇳🇿', phoneLength: 9 },
    { name: 'Nicaragua', code: '+505', flag: '🇳🇮', phoneLength: 8 },
    { name: 'Niger', code: '+227', flag: '🇳🇪', phoneLength: 8 },
    { name: 'Nigeria', code: '+234', flag: '🇳🇬', phoneLength: 10 },
    { name: 'North Korea', code: '+850', flag: '🇰🇵', phoneLength: 9 },
    { name: 'North Macedonia', code: '+389', flag: '🇲🇰', phoneLength: 8 },
    { name: 'Norway', code: '+47', flag: '🇳🇴', phoneLength: 8 },
    { name: 'Oman', code: '+968', flag: '🇴🇲', phoneLength: 8 },
    { name: 'Pakistan', code: '+92', flag: '🇵🇰', phoneLength: 10 },
    { name: 'Palau', code: '+680', flag: '🇵🇼', phoneLength: 7 },
    { name: 'Palestine', code: '+970', flag: '🇵🇸', phoneLength: 9 },
    { name: 'Panama', code: '+507', flag: '🇵🇦', phoneLength: 7 },
    { name: 'Papua New Guinea', code: '+675', flag: '🇵🇬', phoneLength: 7 },
    { name: 'Paraguay', code: '+595', flag: '🇵🇾', phoneLength: 9 },
    { name: 'Peru', code: '+51', flag: '🇵🇪', phoneLength: 9 },
    { name: 'Philippines', code: '+63', flag: '🇵🇭', phoneLength: 10 },
    { name: 'Poland', code: '+48', flag: '🇵🇱', phoneLength: 9 },
    { name: 'Portugal', code: '+351', flag: '🇵🇹', phoneLength: 9 },
    { name: 'Qatar', code: '+974', flag: '🇶🇦', phoneLength: 8 },
    { name: 'Romania', code: '+40', flag: '🇷🇴', phoneLength: 10 },
    { name: 'Russia', code: '+7', flag: '🇷🇺', phoneLength: 10 },
    { name: 'Rwanda', code: '+250', flag: '🇷🇼', phoneLength: 10 },
    { name: 'Saint Kitts and Nevis', code: '+1-869', flag: '🇰🇳', phoneLength: 7 },
    { name: 'Saint Lucia', code: '+1-758', flag: '🇱🇨', phoneLength: 7 },
    { name: 'Saint Vincent and the Grenadines', code: '+1-784', flag: '🇻🇨', phoneLength: 7 },
    { name: 'Samoa', code: '+685', flag: '🇼🇸', phoneLength: 7 },
    { name: 'San Marino', code: '+378', flag: '🇸🇲', phoneLength: 7 },
    { name: 'Sao Tome and Principe', code: '+239', flag: '🇸🇹', phoneLength: 7 },
    { name: 'Saudi Arabia', code: '+966', flag: '🇸🇦', phoneLength: 9 },
    { name: 'Senegal', code: '+221', flag: '🇸🇳', phoneLength: 9 },
    { name: 'Serbia', code: '+381', flag: '🇷🇸', phoneLength: 8 },
    { name: 'Seychelles', code: '+248', flag: '🇸🇨', phoneLength: 7 },
    { name: 'Sierra Leone', code: '+232', flag: '🇸🇱', phoneLength: 8 },
    { name: 'Singapore', code: '+65', flag: '🇸🇬', phoneLength: 8 },
    { name: 'Slovakia', code: '+421', flag: '🇸🇰', phoneLength: 9 },
    { name: 'Slovenia', code: '+386', flag: '🇸🇮', phoneLength: 8 },
    { name: 'Solomon Islands', code: '+677', flag: '🇸🇧', phoneLength: 7 },
    { name: 'Somalia', code: '+252', flag: '🇸🇴', phoneLength: 9 },
    { name: 'South Africa', code: '+27', flag: '🇿🇦', phoneLength: 10 },
    { name: 'South Korea', code: '+82', flag: '🇰🇷', phoneLength: 10 },
    { name: 'South Sudan', code: '+211', flag: '🇸🇸', phoneLength: 9 },
    { name: 'Spain', code: '+34', flag: '🇪🇸', phoneLength: 9 },
    { name: 'Sri Lanka', code: '+94', flag: '🇱🇰', phoneLength: 10 },
    { name: 'Sudan', code: '+249', flag: '🇸🇩', phoneLength: 9 },
    { name: 'Suriname', code: '+597', flag: '🇸🇷', phoneLength: 7 },
    { name: 'Sweden', code: '+46', flag: '🇸🇪', phoneLength: 10 },
    { name: 'Switzerland', code: '+41', flag: '🇨🇭', phoneLength: 9 },
    { name: 'Syria', code: '+963', flag: '🇸🇾', phoneLength: 9 },
    { name: 'Taiwan', code: '+886', flag: '🇹🇼', phoneLength: 10 },
    { name: 'Tajikistan', code: '+992', flag: '🇹🇯', phoneLength: 9 },
    { name: 'Tanzania', code: '+255', flag: '🇹🇿', phoneLength: 10 },
    { name: 'Thailand', code: '+66', flag: '🇹🇭', phoneLength: 9 },
    { name: 'Togo', code: '+228', flag: '🇹🇬', phoneLength: 8 },
    { name: 'Tonga', code: '+676', flag: '🇹🇴', phoneLength: 7 },
    { name: 'Trinidad and Tobago', code: '+1-868', flag: '🇹🇹', phoneLength: 7 },
    { name: 'Tunisia', code: '+216', flag: '🇹🇳', phoneLength: 8 },
    { name: 'Turkey', code: '+90', flag: '🇹🇷', phoneLength: 10 },
    { name: 'Turkmenistan', code: '+993', flag: '🇹🇲', phoneLength: 9 },
    { name: 'Tuvalu', code: '+688', flag: '🇹🇻', phoneLength: 7 },
    { name: 'Uganda', code: '+256', flag: '🇺🇬', phoneLength: 10 },
    { name: 'Ukraine', code: '+380', flag: '🇺🇦', phoneLength: 9 },
    { name: 'United Arab Emirates', code: '+971', flag: '🇦🇪', phoneLength: 9 },
    { name: 'United Kingdom', code: '+44', flag: '🇬🇧', phoneLength: 10 },
    { name: 'United States', code: '+1', flag: '🇺🇸', phoneLength: 10 },
    { name: 'Uruguay', code: '+598', flag: '🇺🇾', phoneLength: 8 },
    { name: 'Uzbekistan', code: '+998', flag: '🇺🇿', phoneLength: 9 },
    { name: 'Vanuatu', code: '+678', flag: '🇻🇺', phoneLength: 7 },
    { name: 'Vatican City', code: '+379', flag: '🇻🇦', phoneLength: 7 },
    { name: 'Venezuela', code: '+58', flag: '🇻🇪', phoneLength: 10 },
    { name: 'Vietnam', code: '+84', flag: '🇻🇳', phoneLength: 9 },
    { name: 'Yemen', code: '+967', flag: '🇾🇪', phoneLength: 9 },
    { name: 'Zambia', code: '+260', flag: '🇿🇲', phoneLength: 10 },
    { name: 'Zimbabwe', code: '+263', flag: '🇿🇼', phoneLength: 9 }
];

function ApplyJobForm() {

    

    const { id } = useParams();

    const [isClearable] = useState(true);
    const [value, setValue] = useState(0);
    const [workStatus, setWorkStatus] = useState('fresher');
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const shimmer = document.querySelector('.shimmer');
    const body = document.querySelector('body');
    const [isLoading, setIsLoading] = useState(false);
    const applyJobFormList = document.querySelector('.applyJobFormList');
    const [inputs, setInputs] = useState({});
    const[croppedimages,setCroppedimage]=useState('');
    const[inatialImage,setInatialImage] = useState('');
   const [reumenameval,setreumenameval]= useState('');
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [showFiledAlert, setShowFiledAlert] = useState(false);
    const { globalState, setGlobalState } = useGlobalState();
    const [serviceImage, setServiceImage] = useState(null);
    const [isImageUploaded, setIsImageUploaded] = useState(false);
    const [pdfFile,setPdfFile] = useState(null);
    const [pdfError,setPdfError] = useState(null);
    const [intailFile,setIntailFile] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});
   //
    const navigate = useNavigate();
    const [personalErrors, setPersonalErrors] = useState({});
    const isMobile = useMediaQuery('(max-width:1024px)');
    const [loginId,setLoginId] = useState(null);

    const [rows, setRows] = useState([{ id: null ,startDate: null, endDate: null, companyName: '', position: '' }]); // Always have one row initially
    const [completionDate, setCompletionDate] = useState(null);
    const [education,setEducation] = useState([]);
    const [educationError,setEducationError] = useState([]);
    useEffect(() => {
        const storedOtpCode = localStorage.getItem('otp_code');
        const storeloginid = localStorage.getItem('login_id');
        const storeemailval = localStorage.getItem('emailval');
        const stcandidate_name = localStorage.getItem('candidate_name');

        //console.log(storeloginid)
        setLoginId(storeloginid)
       
    }, []);
    //console.log(loginId)
    const handleImageUpload = (file) => {
        setPdfFile(file);
        // console.log(file)
        if (file) {
            setIsImageUploaded(true);
            setErrors(prev => ({ ...prev, serviceImage: '' }));
        } else {
            setIsImageUploaded(false);
       }
   };

    // console.log(workStatus)
    const handleChange = (event, newValue) => {
        setValue(newValue);
        window.scrollTo(0, 0); // Scrolls to the top of the page
    };

    const handleNextClick = () => {
    
        if (value < 4) {  // Assuming there are 5 tabs (0 to 4)
            setValue((prevValue) => prevValue + 1);
        } else {
            setShowSuccessPopup(true);
            shimmer.style.display = 'block';
            body.style.overflow = 'hidden';
            applyJobFormList.style.position = 'inherit'; // Show success popup on last tab
        }
        window.scrollTo(0, 0);
    };

    const closeSuccessPopup = () => {
        shimmer.style.display = 'none';
        body.style.overflow = 'inherit';
        applyJobFormList.style.position = 'sticky';
    };

    const handlePrevClick = () => {
        if (value > 0) {  // Ensures that the tab index doesn't go below 0
            setValue((prevValue) => prevValue - 1);
        }
        window.scrollTo(0, 0);
    };

    const handleWorkStatusChange = (event) => {
        setWorkStatus(event.target.id); // 'fresher' or 'experience'
        setFormData({
            ...formData,
            ['work_status']: event.target.id
        });
    };

    // Function to handle adding a new row
    const addRow = () => {
        setRows([...rows, { id:null ,startDate: null, endDate: null, companyName: '', position: '' }]);
    };

    // Function to handle removing a row
    const removeRow = async (index,expId) => {
        const newRows = rows.filter((row, i) => i !== index);
        if (newRows.length === 0) {
            // Ensure there's always at least one row
            setRows([{ id:null,startDate: null, endDate: null, companyName: '', position: '' }]);
        } else {
            setRows(newRows);
        }
        try{
            const response = await axios.get(`${baseURL}/deleteExperience/${expId}`);
            console.log(response)
            
        }catch(err){
            console.log(err)
        }
    };

    
    const updateRow = (index, field, value) => {
        console.log(value);
        const updatedRows = [...rows];
        updatedRows[index][field] = value; 
        setRows(updatedRows);
        setFormData(prevFormData => ({
            ...prevFormData,
            experienceArray: updatedRows,
        }));
        let errors = { ...validationErrors };
        if (field === 'startDate') {
            if (!value) {
                errors[`startDate_${index}`] = 'Start date is required';
            } else {
                delete errors[`startDate_${index}`];
            }
        
            // If endDate is present, validate that it's after startDate
            if (updatedRows[index].endDate && dayjs(updatedRows[index].endDate).isBefore(dayjs(value))) {
                errors[`endDate_${index}`] = 'End date cannot be before start date';
            } else {
                delete errors[`endDate_${index}`];
            }
        }
        
        // Validation for end date only if it's present
        if (field === 'endDate' && value) {
            if (updatedRows[index].startDate && dayjs(value).isBefore(dayjs(updatedRows[index].startDate))) {
                errors[`endDate_${index}`] = 'End date cannot be before start date';
            } else {
                delete errors[`endDate_${index}`];
            }
        }
        
        if (field === 'companyName' && !value.trim()) {
            errors[`companyName_${index}`] = 'Company name is required';
        } else if (field === 'companyName') {
            delete errors[`companyName_${index}`];
        }
        if (field === 'position' && !value.trim()) {
            errors[`position_${index}`] = 'Position is required';
        } else if (field === 'position') {
            delete errors[`position_${index}`];
        }
        
        setValidationErrors(errors);
    };
    
    

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            zIndex: 100,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#d2e2ff' : state.isFocused ? '#eee' : 'white',
            color: state.isSelected ? '#000' : 'inherit',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#000',
        }),
    };


    const [formData, setFormData] = useState({
        firstname:'',
        lastname:'',
        phonenumber:'',
        emailid:'',
        totalexperince:'',
        numbermonth:'',
        counrtryselect:'',
        placeselect:'',
        profilesummary:'',
        experienceArray : [],
      });

      const [errors, setErrors] = useState({
        firstname:'',
        lastname:'',
        phonenumber:'',
        emailid:'',
        totalexperince:'',
        numbermonth:'',
        counrtryselect:'',
        placeselect:'',
        profilesummary:'',
    });

    const handleChangev1 = (e) => {
        const name = e.target.name;
        const value = e.target.value.trim();
        if(e.target.name === "phonenumber"){
            if(e.target.value.trim().length >= 15){
                e.target.value = e.target.value.slice(0, e.target.maxLength);  
            }
        }
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        const error = validate(name, value);
       setErrors((errors) => ({ ...errors, [name]: error[name] }));
        };

        const validate = (name, value) => {
            let error = {};
            if (name === 'job_title' && !value) {
                error.job_title = "Job title is required";
            } 
            return error;
        };
        //console.log(formData)

        const validateAllFields = (fields) => {
            
            
            let errors = {};
            for (let key in fields) {
                const error = validate(key, fields[key]);
                if (error[key]) {
                    errors[key] = error[key];
                }
            }
            return errors;
        };

        const handleCroppedImage = (blob) => {
            // console.log("Cropped Image Blob:", blob);
            setCroppedimage(blob);
            setGlobalState(blob);
            // Handle the blob value here, e.g., set it in state or send it to the backend
          };


          const handletotalexperiance = (selectedOption) => {
            setFormData({
              ...formData,
              totalexperince: selectedOption ? selectedOption.value : '' ,
            });
          };

          const handlenumbermonth = (selectedOption) => {
            setFormData({
              ...formData,
              numbermonth: selectedOption ? selectedOption.value : '' ,
            });
          };

          const handlecounrtyselect = (selectedOption) => {
            
            setFormData({
              ...formData,
              counrtryselect: selectedOption ? selectedOption.value : '' ,
            });
            //console.log(counrtryselect)
          };

          const handleplaceselect = (selectedOption) => {
            setFormData({
              ...formData,
              placeselect: selectedOption ? selectedOption.value : '' ,
            });
          };

          const handleSubmit = async (e) => {
            e.preventDefault();
            //alert();
            if (!validateForm()) {
                return; // Stop submission if validation fails
            }
        
            setIsLoading(true);
            let year_experince_vals = '';
            let month_experince_vals = '';
            if (workStatus === 'experience') {
                year_experince_vals = formData.totalexperince;
                month_experince_vals = formData.numbermonth;
            } else {
                year_experince_vals = 0;
                month_experince_vals = 0;
            }
        
            const data = new FormData(); 
            if (croppedimages !== "") {
                try {
                    const response = await fetch(croppedimages);
                    const blob = await response.blob();
                    const uniqueFileName = `croppedImage_image.jpeg`;
                    const file = new File([blob], uniqueFileName, { type: blob.type });
                    data.append('filename', file);
                } catch (error) {
                    console.error("Error in file processing: ", error);
                    setIsLoading(false);
                    return;
                }
            }
            let country_code=selectedCountry.code;
            data.append('first_name', formData.firstname);
            data.append('last_name', formData.lastname);
            data.append('phone_number', formData.phonenumber);
            data.append('email_id', formData.emailid);
            data.append('profile_summary', formData.profilesummary);
            data.append('country_val', formData.counrtryselect);
            data.append('place_val', formData.placeselect);
            data.append('year_experience', year_experince_vals);
            data.append('month_experince', month_experince_vals);
            data.append('work_status', workStatus);
            data.append('country_code',country_code);
            if(rows){
                data.append('work_experience', JSON.stringify(rows));
            }
            for (let [key, value] of data.entries()) {
                console.log(key, value);
            }
            try {
                const storeloginid = await localStorage.getItem('login_id');
                
                const response = await axios.post(`${baseURL}/addbasicfromdetails/${storeloginid}`, data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',  // Ensure correct content type
                    },
                });
                //console.log('hi',response)
                if (response.data.status == 1) {
                    setPdfError('')
                    setMessage(response.data.message);
                    setIsSuccess(true);
                    setShowSuccessAlert(true);
                    setShowFiledAlert(false);
                    setTimeout(() => {
                        setIsLoading(false);
                        setValue((prevValue) => prevValue + 1);
                        window.scrollTo({
                            top: 10,
                            behavior: 'smooth', // smooth scroll to top
                        });
                    }, 2000);
                } else {
                    setMessage(response.data.message);
                    setIsSuccess(false);
                    setShowFiledAlert(true);
                    setShowSuccessAlert(false);
                }
            } catch (error) {
                console.error("Error submitting form: ", error);
                setMessage('Failed to add client. Please try again.');
                setIsSuccess(false);
                setShowFiledAlert(true);
                setShowSuccessAlert(false);
            } finally {
                //setIsLoading(false);
                fetchBasicDetails();
            }
        };
        
        
       //upload resume 
       const handleResume = async () => {
            
            if(!pdfFile){
                setPdfError('*choose resume')
                return false;
            }else{
                setIsLoading(true)
                setPdfError('')
                const formData = new FormData();
                formData.append('resume', pdfFile);
                
                
                try {
                    const storeloginid = localStorage.getItem('login_id');
                    const response = await axios.post(`${baseURL}/uploadResume/${storeloginid}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    console.log(response)
                    if (response.data.status) {
                        fetchResume();
                        setMessage(response.data.message);
                        setIsSuccess(true);
                        setShowSuccessAlert(true);
                        setShowFiledAlert(false);
                        setTimeout(() => {
                            setValue((prevValue) => prevValue + 1)
                            setIsLoading(false)
                        },1000)
                        
                    } else {
                        setMessage(response.data.message);
                        setIsSuccess(false);
                        setShowFiledAlert(true);
                        setShowSuccessAlert(false);
                    }
                } catch (error) {
                console.log(error)
                }
                
            }
       }

// console.log(croppedimages)
             //validation
    const validateForm = () => {
        const newErrors = {};
        const errors = {};
        //Validate Job Title
        if(croppedimages=='' && globalState == ""){
            newErrors.cropedimagv = 'Please upload image'; 
        }

        if (!formData.firstname.trim()) {
            newErrors.firstname = 'First Name is required';
        }

        if (!formData.lastname.trim()) {
            newErrors.lastname = 'Last Name is required';
        }

        if (!formData.phonenumber.trim()) {
            newErrors.phonenumber = 'Phone number is required';
        }
        if (!formData.emailid.trim()) {
            newErrors.emailid = 'Email id is required';
        }
        if (!formData.profilesummary.trim()) {
            newErrors.profilesummary = 'Profile summary is required';
        }
        if (!formData.counrtryselect.trim()) {
            newErrors.counrtryselect = 'Country is required';
        }
        if (!formData.placeselect.trim()) {
            newErrors.placeselect = 'Place is required';
        }
        if(workStatus === 'experience'){
            rows.forEach((row, index) => {
                if (!row.startDate) {
                    newErrors[`startDate_${index}`] = 'Start date is required';
                    errors[`startDate_${index}`] = 'Start date is required';
                }
                
                if (!row.companyName.trim()) {
                    newErrors[`companyName_${index}`] = 'Company name is required';
                    errors[`companyName_${index}`] = 'Company name is required';
                }
                if (!row.position.trim()) {
                    newErrors[`position_${index}`] = 'Position is required';
                    errors[`position_${index}`] = 'Position is required';
                }
            });
        }
        setValidationErrors(errors);
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const hideAlertAfterDelay = () => {
        setTimeout(() => {
            setShowSuccessAlert(false);
            setShowFiledAlert(false);
            setMessage('');
        }, 10000); // 10000 milliseconds = 10 seconds
    };


    //person details

    const [formDataperson, setFormDataperson] = useState({
        gender_val: '',
        marital_status: '',
        day_val: '',
        month_val: '',
        year_val: '',
        language: [],
      });

      const handlepersondetails = async (e) => {
        e.preventDefault();
    
        const errors = {};
    
        // Validate gender
        if (!formDataperson.gender_val) {
            errors.gender = "Gender is required.";
        }
    
        // Validate marital status
        if (!formDataperson.marital_status) {
            errors.maritalStatus = "Marital status is required.";
        }
    
        // Validate date of birth
        if (!formDataperson.day_val || !formDataperson.month_val || !formDataperson.year_val) {
            errors.dateOfBirth = "Complete date of birth is required.";
        }
    
        // Validate permanent address
        console.log(formDataperson)
        if (!formDataperson.permenent_adress) {
            errors.permenentadress = "Permanent address is required.";
        }
        if (!formDataperson.home_town) {
            errors.hometown = "Home town is required.";
        }
    
        // Validate pincode
        const pincodeRegex = /^[0-9]{6}$/; // Example: 6-digit pincode
        if (!formDataperson.pincode_val || !pincodeRegex.test(formDataperson.pincode_val)) {
            errors.pincode = "A valid 6-digit pincode is required.";
        }
    
        // Validate languages
        // console.log(formDataperson.language.length)
        formDataperson.language.some(lang => console.log(lang.language_val,lang.proficiancy_val,lang))
        if (formDataperson.language.length === 0 || 
            formDataperson.language.some(lang => !lang.language_val || !lang.proficiancy_val)) {
            errors.languages = "At least one language with proficiency is required.";
        }
    
        
    
        setPersonalErrors(errors);
    
        if (Object.keys(errors).length === 0) {
            setIsLoading(true)
            // console.log("Form data:", formDataperson);
            const formData = new FormData();
            formData.append('gender_val', formDataperson.gender_val);
            formData.append('marital_status', formDataperson.marital_status);
            formData.append('day_val', formDataperson.day_val);
            formData.append('month_val', formDataperson.month_val);
            formData.append('year_val', formDataperson.year_val);
            formData.append('permenent_adress', formDataperson.permenent_adress);
            formData.append('home_town', formDataperson.home_town);
            formData.append('pincode_val', formDataperson.pincode_val);
        
            // Append languages as a JSON string
            formData.append('language', JSON.stringify(formDataperson.language));
                
                
                try {
                    const storeloginid = await localStorage.getItem('login_id');
                    const response = await axios.post(`${baseURL}/insertPersonalDetails/${storeloginid}`, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                     console.log(formDataperson)
                    // console.log(response.data)
                    if (response.data.status) {
                        setMessage(response.data.message);
                        setIsSuccess(true);
                        setShowSuccessAlert(true);
                        setShowFiledAlert(false);
                        setTimeout(() => {
                            setValue((prevValue) => prevValue + 1)
                            setIsLoading(false)
                        },1000)
                        
                    } else {
                        setMessage(response.data.message);
                        setIsSuccess(false);
                        setShowFiledAlert(true);
                        setShowSuccessAlert(false);
                    }
                    setTimeout(() => {
                        setIsLoading(false);
                    },1500)
                } catch (error) {
                console.log(error)
                }
            // Proceed with form submission
        } else {
            console.log("Validation errors:", errors);
        }
    };
    //fetch basic details
    const fetchBasicDetails = async () => {
        const storeloginid =  localStorage.getItem('login_id');
        if (!storeloginid) {
            console.error("Login ID not found in localStorage");
            return; 
        }

        try {
            const response = await axios.get(`${baseURL}/getBasicDetails/${storeloginid}`);
           // console.log("Full Response: ", response.data);
            
            if (response.data.status === 'success') {
                const data = response.data.data;
                //console.log("Fetched Data: ", data);
                
                setFormData({
                    firstname: data.first_name || '',
                    lastname: data.last_name || '',
                    phonenumber: data.phone_number || '',
                    emailid: data.email_id || '',
                    profilesummary: data.profile_summary || '',
                    counrtryselect: data.country_val || '',
                    placeselect: data.place_val || '',
                    totalexperince: data.year_experience || '',
                    numbermonth: data.month_experince || '',
                    work_status: data.work_status || '',
                    country_code : data.country_code || "",
                });
                const country = countryCodes.find(c => c.code === data.country_code);
                setSelectedCountry(country)
                if (data.cropped_image) {
                    setGlobalState(mediaPath +data.cropped_image);
                }

                setWorkStatus(data.work_status);

                // Handle experience array properly
                const experienceData = data.experience || [];
                if (experienceData.length > 0) {
                    const formattedRows = experienceData.map(exp => ({
                        id: exp.id,
                        startDate: exp.start_date,
                        endDate: exp.end_date,
                        companyName: exp.name_company,
                        position: exp.job_position,
                    }));
                    setRows(formattedRows);
                } else {
                    //console.log("No experience data available.");
                }
                //console.log("new rows",rows)
                
            } else {
                console.error("Failed to fetch details: ", response.data.message);
            }
        } catch (err) {
            console.error("Error fetching basic details: ", err);
        }
    };

    


    //fetch resume
        const fetchResume = async () => {
            const storeloginid = localStorage.getItem('login_id');
            try {
                const response = await axios.get(`${baseURL}/getResume/${storeloginid}`);
                console.log(response.data)
                if (response.data.status == 1) {
                    const data = response.data.data;
                    // console.log(data.resume_pdf)
                    const filePath=data.resume_pdf;
                    const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
                    setIntailFile(mediaPath+data.resume_pdf)
                    setPdfFile(mediaPath + data.resume_pdf)
                    setreumenameval(fileName)
                } else {
                    // Handle error if needed
                }
            } catch (err) {
                //console.log(err);
                // Handle error if needed
            }
        };
    

    useEffect(() => {       
    
        fetchBasicDetails();
        fetchResume();
    }, []);     

    //console.log(pdfFile)
    //
    //alert(formDataperson.gender_val)
    //apply job section

    const handleapplysubmit = () => {
    const jobId = id;
    setIsLoading(true)
    axios.post(`${baseURL}/applyjobscandidate?job_id=${jobId}&login_id=${loginId}`).then(response =>{
         console.log(response.data)
        
        
        if(response.data.status == 1){
            setMessage(response.data.message);
            toast.success('Job Applied Succesfully')
            setIsSuccess(true);
            setShowSuccessAlert(true);
            setShowFiledAlert(false);
            setTimeout(() => {
                //setValue((prevValue) => prevValue + 1)
                navigate('/jobs')
            },2000)
        }
        else if(response.data.status == 2){
            setMessage(response.data.message);
            setIsSuccess(false);
            setShowFiledAlert(true);
            setShowSuccessAlert(false);
            toast.error('Job Already Applied');
        }
        else if(response.data.status == 3){
            toast.error('Please fill the profile and resume datas!');
        }
        else{
            setMessage(response.data.message);
            setIsSuccess(false);
            setShowFiledAlert(true);
            setShowSuccessAlert(false);
        }
        setTimeout(() => {
            setIsLoading(false);
        },1500)
    })
    .catch(error => {
        // handle error (e.g., show error message)
        // console.log(error)
        setMessage('Failed to add client. Please try again.');
        setIsSuccess(false);
        setShowFiledAlert(true);
         setShowSuccessAlert(false);
         hideAlertAfterDelay();
         setIsLoading(false);
    })
    }
    //education submit
    const validateEducation = () => {
        setEducationError([])
        let valid = true;
        if(education.EightthStandYes){
            // if(education.EightthStandYes === 'Yes'){
            //     if(!education.eightthSchool){
            //         setEducationError(prevEducation => ({
            //             ...prevEducation,
            //             ['eightthSchool']: 'Required'
            //         }));
            //         valid = false;
            //     }

            //     if(!education.EightCompleDate){
            //         setEducationError(prevEducation => ({
            //             ...prevEducation,
            //             ['EightCompleDate']: 'Required'
            //         }));
            //         valid = false;
            //     }
            // }

        }else{
            setEducationError(prevEducation => ({
                ...prevEducation,
                ['EightthStandYes']: 'You must select one of these options'
            }));
            valid = false;
        }

        if(education.tenthStandYes){
            // if(education.tenthStandYes === 'Yes'){
            //     if(!education.tenthSchool){
            //         setEducationError(prevEducation => ({
            //             ...prevEducation,
            //             ['tenthSchool']: 'Required'
            //         }));
            //         valid = false;
            //     }

            //     if(!education.tewlveCompleteDate){
            //         setEducationError(prevEducation => ({
            //             ...prevEducation,
            //             ['tewlveCompleteDate']: 'Required'
            //         }));
            //         valid = false;
            //     }
            // }

        }else{
            setEducationError(prevEducation => ({
                ...prevEducation,
                ['tenthStandYes']: 'You must select one of these options'
            }));
            valid = false;
        }

        if(education.twelvethStand){
            // if(education.twelvethStand === 'Yes'){
            //     if(!education.tenthSchool){
            //         setEducationError(prevEducation => ({
            //             ...prevEducation,
            //             ['twelveSchool']: 'Required'
            //         }));
            //         valid = false;
            //     }

            //     if(!education.twelvethStand){
            //         setEducationError(prevEducation => ({
            //             ...prevEducation,
            //             ['twelvethStand']: 'Required'
            //         }));
            //         valid = false;
            //     }
            // }

        }else{
            setEducationError(prevEducation => ({
                ...prevEducation,
                ['twelvethStand']: 'You must select one of these options'
            }));
            valid = false;
        }

        if(education.studyCollage){
            if(education.studyCollage !== 'didntAttend'){
                if(!education.NameOfCollege){
                    setEducationError(prevEducation => ({
                        ...prevEducation,
                        ['NameOfCollege']: 'Name of college is required'
                    }));
                    valid = false;
                }

                if(education.completedCourseBachelors){
                    if(education.completedCourseBachelors === 'Yes'){
                        if(!education.BachelorsCompleteDate){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['BachelorsCompleteDate']: 'Completion date is required.'
                            }));
                            valid = false;
                        }
                    }else{
                        if(!education.bachelorReason){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['BachelorsCompleteDate']: 'Reason required.'
                            }));
                            valid = false;
                        }
                    }
                }else{
                    setEducationError(prevEducation => ({
                        ...prevEducation,
                        ['completedCourseBachelors']: 'You must select one of these options'
                    }));
                    valid = false;
                }
                if(education.completedCourseMasters){
                    if(education.completedCourseMasters === 'Yes'){
                        if(!education.MastersCompleteDate){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['MastersCompleteDate']: 'Completion date is required.'
                            }));
                            valid = false;
                        }
                        if(!education.MastersCollege){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['MastersCollege']: 'College Name is required.'
                            }));
                            valid = false;
                        }
                        
                    }else{
                        if(!education.MastersReason){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['MastersReason']: 'Reason required.'
                            }));
                            valid = false;
                        }
                        if(!education.MastersCollege){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['MastersCollege']: 'College Name is required.'
                            }));
                            valid = false;
                        }
                    }
                }
                if(education.completedCoursePhd){
                    if(education.completedCoursePhd === 'Yes'){
                        if(!education.PhdCompleteDate){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['PhdCompleteDate']: 'Completion date is required.'
                            }));
                            valid = false;
                        }
                        if(!education.PhdCollege){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['PhdCollege']: 'College Name is required.'
                            }));
                            valid = false;
                        }

                    }else{
                        if(!education.PhdReason){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['PhdReason']: 'Reason required.'
                            }));
                            valid = false;
                        }
                        if(!education.PhdCollege){
                            setEducationError(prevEducation => ({
                                ...prevEducation,
                                ['PhdCollege']: 'College Name is required.'
                            }));
                            valid = false;
                        }
                    }
                }
            }

        }else{
            setEducationError(prevEducation => ({
                ...prevEducation,
                ['studyCollage']: 'You must select one of these options'
            }));
            valid = false;
        }
        

        return valid;
        

        
    }
    const handleEducation = async () => {
        
        if(!validateEducation()){
            return false;
        }

        
        try{
            setIsLoading(true)
            const formData = new FormData();
            formData.append('eight_status',education.EightthStandYes)
            formData.append('tenth_status',education.tenthStandYes)
            formData.append('twelve_status',education.twelvethStand)
            formData.append('college_status',education.studyCollage)
            formData.append('college_name',education.NameOfCollege)
            formData.append('degree_status',education.completedCourseBachelors)
            education.BachelorsCompleteDate && formData.append('degree_date',education.BachelorsCompleteDate)
            education.bachelorReason && formData.append('degree_reason',education.bachelorReason)

            education.MastersCollege && formData.append('master_college',education.MastersCollege)
            education.completedCourseMasters && formData.append('master_status',education.completedCourseMasters)
            education.MastersCompleteDate && formData.append('master_date',education.MastersCompleteDate)
            education.MastersReason && formData.append('master_reason',education.MastersReason)

            education.PhdCollege && formData.append('phd_college',education.PhdCollege)
            education.completedCoursePhd && formData.append('phd_status',education.completedCoursePhd)
            education.PhdCompleteDate && formData.append('phd_date',education.PhdCompleteDate)
            education.PhdReason && formData.append('phd_reason',education.PhdReason)

            const storeloginid = await localStorage.getItem('login_id');
            const response = await axios.post(`${baseURL}/handleEducation/${storeloginid}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
                
            });
            //alert(response)
            console.log('hi',response)
            if(response.data.status == 1){
                setMessage(response.data.message);
                toast.success('Education Details Updated')
                setIsSuccess(true);
                setShowSuccessAlert(true);
                setShowFiledAlert(false);
                setTimeout(() => {
                    setIsLoading(false)
                    setValue((prevValue) => prevValue + 1)
                    //navigate('/jobs')
                },2000)
            }
            
        }catch(err){
            console.log(err)
            
        }
    }

    //fetch_education
    useEffect(()=>{
        const fetchEducation = async () => {
            const storeloginid = await localStorage.getItem('login_id');
            try {
                const response = await axios.get(`${baseURL}/Education/${storeloginid}`);
                //console.log('education',response)
                if (response.data.status == 1) {
                    const data = response.data.data;
                    setEducation({
                        EightthStandYes:data.eight_class_status || '',
                        tenthStandYes:data.tenth_class_status || '',
                        twelvethStand:data.twelth_class_status || '',
                        studyCollage:data.collage_status || '',

                        completedCourseBachelors:data.degree_completed_status || '',
                        BachelorsCompleteDate:data.degree_completed_date || '',
                        bachelorReason:data.degree_non_completed_reason || '',
                        NameOfCollege:data.degree_collage_name || '',

                        completedCourseMasters:data.master_completed_status || '',
                        MastersCompleteDate:data.master_completed_date || '',
                        MastersReason:data.master_non_completed_reason || '',
                        MastersCollege:data.master_collage_name || '',

                        completedCoursePhd:data.phd_completed_status || '',
                        PhdCompleteDate:data.phd_completed_date || '',
                        PhdReason:data.phd_non_completed_reason || '',
                        PhdCollege:data.phd_collage_name || '',
                    })
                } else {
                   
                }
            } catch (err) {
                //console.log(err);
                
            }
        };
    
        fetchEducation();
    },[])

    //fetch applied button text if applied or not
    const [applybutton,setapplybutton]=useState('');
    useEffect(()=>{
        const jobId = id;
        const login_id =localStorage.getItem('login_id');
        const fetchapplybutton=async ()=>{
            try{
                const response = await axios.get(`${baseURL}/applybuttoncheck`, {
                    params: { id: jobId,login_id:login_id },
                });
                //console.log(response.data)
                // setValue((prevValue) => {
                //     //console.log("Previous Value:", prevValue);  // This will log the current value before updating
                //     return prevValue + 1;
                // });
            setapplybutton(response.data.applybutton)
            if(response.data.review_status == 1){
                setValue(4)
            }
            // else{
            //     setValue((prevValue) => {
            //         //console.log("Previous Value:", prevValue);  // This will log the current value before updating
            //         console.log(prevValue)
            //         return prevValue + 1;
            //     });
            // }
            }
            catch(err){
                console.log(err)
            }
        }
        fetchapplybutton();
        
    }, [id]);

    const [selectedCountry, setSelectedCountry] = useState(countryCodes[74]);
    const setCountryCode = (e) => {
        const country = countryCodes.find(c => c.code === e.target.value);
        setSelectedCountry(country);
    };

    return (
        <>
        {showSuccessPopup && (
            <div className="jobAppliedSuccessPopup">
                <div className="jobAppliedSuccessPopupMain">
                    <div className="jobAppliedSuccessPopupImg">
                        <img src={successImg} alt="" />
                    </div>
                    <div className="jobAppliedSuccessPopupDetails">
                        <h2>Job applied successfully</h2>
                        <p>Your application was submitted successfully. We’ll review it and contact you if you're selected.</p>
                        <Link to={`${path}/jobs`} className="okBtn" onClick={closeSuccessPopup}>Okay</Link>
                    </div>
                </div>
            </div>
            )}
            <section id="applyJobForm">
                <div className="container">
                    <BackBtn />
                    <div className="applyJobFormMain">
                        <div className="applyJobFormMenu">
                            <div className="applyJobFormMenuHead">
                                <h2 className="subTitle">Quick links</h2>
                            </div>
                            <div className="applyJobFormMenuBody">
                                <Tabs
                                orientation={isMobile ? "horizontal" : "vertical"}
                                    variant="scrollable"
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="Vertical tabs example"
                                >
                                    {/* <Tab label="Profile" {...a11yProps(0)} />
                                    <Tab label="Resume" {...a11yProps(1)} />
                                    <Tab label="Education" {...a11yProps(2)} />
                                    <Tab label="Personal Details" {...a11yProps(3)} />
                                    <Tab label="Review" {...a11yProps(4)}/> */}

                                    <Tab label="Profile" onClick={() => setValue(0)} />
                                    <Tab label="Resume" onClick={() => setValue(1)} />
                                    <Tab label="Education" onClick={() => setValue(2)} />
                                    <Tab label="Personal Details" onClick={() => setValue(3)} />
                                    <Tab label="Review" onClick={() => setValue(4)} />
                                </Tabs>
                            </div>
                        </div>
                        <div className="applyJobFormList">
                            <TabPanel value={value} index={0}>
                                <div className="applyJobFormListBox">
                                    <div className="applyJobFormListBoxHead">
                                        <h2 className="subTitle">Profile Details</h2>
                                    </div>
                                    <div className="applyJobFormListBoxHeadBody">
                                        <form action="" >
                                            <div className="formGroup col-1">
                                                <label htmlFor="">Profile Image</label>
                                                <ProfileImage onCropCompleteLast={handleCroppedImage} initialImageSrc={globalState}/>
                                                {errors.cropedimagv && <p className="error">{errors.cropedimagv}</p>}
                                            </div>
                                            <div className="formGroup">
                                                <label htmlFor="">First Name</label>
                                                <input 
                                                type="text" 
                                                name="firstname" 
                                                onKeyUp={handleChangev1} 
                                                onChange={handleChangev1} 
                                                value={formData.firstname} 
                                                onInput={(e) => {e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '');}}
                                                pattern="[A-Za-z]+"
                                                required />
                                                {errors.firstname && <p className="error">{errors.firstname}</p>}
                                            </div>
                                            <div className="formGroup">
                                                <label htmlFor="">Last Name</label>
                                                <input type="text" name="lastname" onKeyUp={handleChangev1} onChange={handleChangev1} value={formData.lastname} 
                                                onInput={(e) => {e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '');}}
                                                pattern="[A-Za-z]+"
                                                required />
                                                {errors.lastname && <p className="error">{errors.lastname}</p>}
                                            </div>
                                            <div className="formGroup">
                                                <label htmlFor="">Phone Number</label>
                                                <div className="phoneInput">
                                                    <select value={selectedCountry.code} onChange={setCountryCode}> 
                                                        {countryCodes.map((country) => (
                                                            <option key={country.code} value={country.code}>
                                                                {country.flag} {country.code}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <input 
                                                        type="number" 
                                                        name="phonenumber" 
                                                        onKeyUp={handleChangev1} 
                                                        onChange={handleChangev1} 
                                                        value={formData.phonenumber}
                                                        minLength={selectedCountry.phoneLength}
                                                        maxLength={selectedCountry.phoneLength}
                                                    />
                                                </div>
                                                {errors.phonenumber && <p className="error">{errors.phonenumber}</p>}
                                            </div>
                                            <div className="formGroup">
                                                <label htmlFor="">Email</label>
                                                <input type="email" name="emailid" onKeyUp={handleChangev1} onChange={handleChangev1} value={formData.emailid}/>
                                                {errors.emailid && <p className="error">{errors.emailid}</p>}
                                            </div>
                                            <div className="formGroup">
                                                <label htmlFor="">Work History</label>
                                                <div className="formRadioGroup">
                                                    <div className="formRadioGroupBox">
                                                        <input type="radio" id='fresher' name="workStatus" checked={workStatus === 'fresher'} 
                                                            onChange={handleWorkStatusChange} />
                                                        <label htmlFor="fresher">
                                                            <div className="radioIcon"></div>
                                                            <div className="radioText">Fresher</div>
                                                        </label>
                                                    </div>
                                                    <div className="formRadioGroupBox">
                                                        <input type="radio" id='experience' name="workStatus" checked={workStatus === "experience"} 
                                                            onChange={handleWorkStatusChange} />
                                                        <label htmlFor="experience">
                                                            <div className="radioIcon"></div>
                                                            <div className="radioText">Experience</div>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* {console.log(workStatus)} */}
                                            {workStatus === 'experience' && (
                                                <div className="formGroup col-1 experienceArea">
                                                    {/* <label htmlFor="">Total experience</label>
                                                    <div className="formGroupDorpdownList">
                                                        <div className="formGroupDorpdownListBox">
                                                            <Select
                                                                options={year}
                                                                placeholder="Number of Year"
                                                                isSearchable={true}
                                                                className="customSelect"
                                                                isClearable={isClearable}
                                                      F          styles={customStyles}
                                                                name="totalexperince"
                                                                
                                                                value={year.find(p=>p.value === formData.totalexperince)}
                                                                onChange={handletotalexperiance}
                                                            />
                                                            {errors.totalexperince && <p className="error">{errors.totalexperince}</p>}
                                                        </div>
                                                        {console.log(formData)}
                                                        <div className="formGroupDorpdownListBox">
                                                            <Select
                                                                options={month}
                                                                placeholder="Number of Month"
                                                                isSearchable={true}
                                                                className="customSelect"
                                                                isClearable={isClearable}
                                                                styles={customStyles}
                                                                name="numbermonth"
                                                                
                                                                value={month.find(p=>p.value === formData.numbermonth)}
                                                                onChange={handlenumbermonth}
                                                            />
                                                            {errors.numbermonth && <p className="error">{errors.numbermonth}</p>}
                                                        </div>
                                                        
                                                    </div> */}
                                                    <div className="formTable">
                                                        <div className="formTableHead">
                                                            <div className="formTableHeadBox">Start Date</div>
                                                            <div className="formTableHeadBox">End Date</div>
                                                            <div className="formTableHeadBox">Name of Organization / Company</div>
                                                            <div className="formTableHeadBox">Position</div>
                                                            <div className="formTableHeadBox"></div>
                                                        </div>
                                                        <div className="formTableBody">

                                                            {/* Render Rows Dynamically */}
                                                            {rows.map((row, index) => (
                                                                <div key={index} className="formTableBodyRow">
                                                                    <div className="formTableBodyBox">
                                                                        <label htmlFor="" className="formTableLabel">Start Date</label>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DatePicker
                                                                                views={['year', 'month']}
                                                                                value={row.startDate ? dayjs(row.startDate) : null}
                                                                                onChange={(newValue) => {
                                                                                    if (newValue && newValue.isValid()) {
                                                                                        const formattedValue = newValue.format('MMM YYYY');
                                                                                        updateRow(index, 'startDate', formattedValue);
                                                                                    }
                                                                                }}
                                                                                renderInput={(params) => <input {...params} />}
                                                                                format="MMM YYYY"
                                                                            />
                                                                        </LocalizationProvider>
                                                                        {validationErrors[`startDate_${index}`] && (
                                                                            <div className="error">{validationErrors[`startDate_${index}`]}</div>
                                                                        )}
                                                                    </div>

                                                                    <div className="formTableBodyBox">
                                                                        <label htmlFor="" className="formTableLabel">End Date</label>
                                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                            <DatePicker
                                                                                views={['year', 'month']}
                                                                                value={row.endDate ? dayjs(row.endDate) : null}
                                                                                onChange={(newValue) => {
                                                                                    if (newValue && newValue.isValid()) {
                                                                                        const formattedValue = newValue.format('MMM YYYY');
                                                                                        updateRow(index, 'endDate', formattedValue);
                                                                                    }
                                                                                }}
                                                                                renderInput={(params) => <input {...params} />}
                                                                                format="MMM YYYY"
                                                                            />
                                                                        </LocalizationProvider>
                                                                        {validationErrors[`endDate_${index}`] && (
                                                                            <div className="error">{validationErrors[`endDate_${index}`]}</div>
                                                                        )}
                                                                    </div>

                                                                    <div className="formTableBodyBox">
                                                                        <label htmlFor="" className="formTableLabel">Name of Organization / Company</label>
                                                                        <input
                                                                            type="text"
                                                                            value={row.companyName}
                                                                            onChange={(e) => updateRow(index, 'companyName', e.target.value)}
                                                                        />
                                                                        {validationErrors[`companyName_${index}`] && (
                                                                            <div className="error">{validationErrors[`companyName_${index}`]}</div>
                                                                        )}
                                                                    </div>

                                                                    <div className="formTableBodyBox">
                                                                        <label htmlFor="" className="formTableLabel">Position</label>
                                                                        <input
                                                                            type="text"
                                                                            value={row.position}
                                                                            onChange={(e) => updateRow(index, 'position', e.target.value)}
                                                                        />
                                                                        {validationErrors[`position_${index}`] && (
                                                                            <div className="error">{validationErrors[`position_${index}`]}</div>
                                                                        )}
                                                                    </div>

                                                                    <div className="formTableBodyBox">
                                                                        {index > 0 && (
                                                                            <button
                                                                                type="button"
                                                                                className="deleteformTableBodyRowBtn"
                                                                                onClick={() => removeRow(index,row.id)}
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            <div className="formTableBodyRow">
                                                                <div className="formTableBodyBox">
                                                                    <button type="button" className="addformTableBodyRowBtn" onClick={addRow} style={{marginLeft: 'auto'}}>
                                                                        Add More
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {/* <div className="formGroup col-1">
                                                <label htmlFor="">Current location</label>
                                                <div className="formGroupDorpdownList">
                                                    <div className="formGroupDorpdownListBox">
                                                        <Select
                                                            options={locations}
                                                            placeholder="Select Country"
                                                            isSearchable={true}
                                                            className="customSelect"
                                                            isClearable={isClearable}
                                                            styles={customStyles}
                                                            name="counrtryselect"
                                                            onChange={handlecounrtyselect}
                                                            value={locations.find(p=>p.value === formData.counrtryselect)}
                                                        />
                                                        {errors.counrtryselect && <p className="error">{errors.counrtryselect}</p>}
                                                    </div>
                                                    
                                                    <div className="formGroupDorpdownListBox">
                                                        <Select
                                                            options={place}
                                                            placeholder="Select Place"
                                                            isSearchable={true}
                                                            className="customSelect"
                                                            isClearable={isClearable}
                                                            styles={customStyles}
                                                            name="placeselect"
                                                            onChange={handleplaceselect}
                                                            value={place.find(p=>p.value === formData.placeselect)}
                                                        />
                                                        {errors.placeselect && <p className="error">{errors.placeselect}</p>}
                                                    </div>
                                                    
                                                </div>
                                            </div> */}
                                            <div className="formGroup">
                                                <label htmlFor="">Country</label>
                                                <input type="text" name="counrtryselect" onKeyUp={handleChangev1} onChange={handleChangev1} value={formData.counrtryselect} 
                                                onInput={(e) => {e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '');}}
                                                pattern="[A-Za-z]+"
                                                required />
                                                {errors.counrtryselect && <p className="error">{errors.counrtryselect}</p>}
                                            </div>
                                            <div className="formGroup">
                                                <label htmlFor="">Place</label>
                                                <input type="text" name="placeselect" onKeyUp={handleChangev1} onChange={handleChangev1} value={formData.placeselect} 
                                                onInput={(e) => {e.target.value = e.target.value.replace(/[^a-zA-Z]/g, '');}}
                                                pattern="[A-Za-z]+"
                                                required />
                                                {errors.placeselect && <p className="error">{errors.placeselect}</p>}
                                            </div>
                                            <div className="formGroup col-1">
                                                <label htmlFor="">Profile Summary</label>
                                                <textarea name="profilesummary" onKeyUp={handleChangev1} onChange={handleChangev1} value={formData.profilesummary}></textarea>
                                                {errors.profilesummary && <p className="error">{errors.profilesummary}</p>}
                                            </div>
                                        </form>
                                    </div>
                                    <div className="applyJobFormListBoxHeadFooter">
                                        {/* <div className="nextFormBtn" onClick={handleNextClick}>Submit Profile & Continue <PiCaretRightBold /></div> */}
                                        <button className="nextFormBtn" onClick={handleSubmit} disabled={isLoading}>{isLoading ? <Loader /> : 'Continue'}</button>
                                        {/* {isLoading ? <Loader /> : 'Save'} */}
                                    </div>
                                    
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <div className="applyJobFormListBox">
                                    <div className="applyJobFormListBoxHead">
                                        <h2 className="subTitle">Upload Resume</h2>
                                    </div>
                                    <div className="applyJobFormListBoxHeadBody">
                                        <form action="">
                                            <UploadResume onHandleImageUpload={handleImageUpload} existingResume={intailFile} reumenameval={reumenameval}/>
                                            {pdfError && <p className="error">{pdfError}</p>}
                                        </form>
                                    </div>
                                    <div className="applyJobFormListBoxHeadFooter">
                                        <div className="prevFormBtn" onClick={handlePrevClick}><PiCaretLeftBold /> Back</div>
                                        <div className="nextFormBtn" onClick={handleResume}>{isLoading ? <Loader /> : <>Continue <PiCaretRightBold /></>}
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                                <div className="applyJobFormListBox">
                                    <div className="applyJobFormListBoxHead">
                                        <h2 className="subTitle">Education Details</h2>
                                    </div>
                                    <div className="applyJobFormListBoxHeadBody">
                                        <form action="">
                                            <EducationForm education={education} setEducation={setEducation} educationError={educationError} setEducationError={setEducationError}/>
                                        </form>
                                    </div>
                                    <div className="applyJobFormListBoxHeadFooter">
                                        <div className="prevFormBtn" onClick={handlePrevClick}><PiCaretLeftBold /> Back</div>
                                        <div className="nextFormBtn" onClick={handleEducation}disabled={isLoading}>{isLoading ? <Loader /> : <>Continue <PiCaretRightBold /></>}</div>
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={3}>
                                <div className="applyJobFormListBox">
                                    <div className="applyJobFormListBoxHead">
                                        <h2 className="subTitle">Personal Details</h2>
                                    </div>
                                    <div className="applyJobFormListBoxHeadBody">
                                        <form action="">
                                            <PersonalDetailsForm formDataperson={formDataperson} setFormDataperson={setFormDataperson} personalErrors={personalErrors} setPersonalErrors={setPersonalErrors}/>
                                        </form>
                                    </div>
                                    <div className="applyJobFormListBoxHeadFooter">
                                        <div className="prevFormBtn" onClick={handlePrevClick}><PiCaretLeftBold /> Back</div>
                                        <div className="nextFormBtn" onClick={handlepersondetails} disabled={isLoading}> {isLoading ? <Loader /> : 'Continue'}<PiCaretRightBold /></div>
                                    </div>
                                </div>
                            </TabPanel>
                            <TabPanel value={value} index={4}>
                                <div className="applyJobFormListBox">
                                    <div className="applyJobFormListBoxHead">
                                        <h2 className="subTitle">Review & Apply</h2>
                                    </div>
                                    <div className="applyJobFormListBoxHeadBody">
                                        {/* {console.log(formDataperson)} */}
                                        <ReviewForm setValue={setValue} basicDatails={formData}   resumeFile={intailFile} experience={rows} education={education} />
                                    </div>
                                    <div className="applyJobFormListBoxHeadFooter">
                                        <div className="prevFormBtn" onClick={handlePrevClick}><PiCaretLeftBold /> Back</div>
                                        <button className="nextFormBtn" onClick={handleapplysubmit} disabled={isLoading || applybutton === 'Applied'}>{isLoading ? <Loader /> :applybutton}</button>
                                        {/* <div className="nextFormBtn" onClick={handleNextClick}>Apply Now <PiCaretRightBold /></div> */}
                                    </div>
                                </div>
                            </TabPanel>
                        </div>
                    </div>
                </div>
            </section>
            <HomeContact />
        </>
    );
}


export default ApplyJobForm;
